import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { ClassicAppService } from '@core/services/classic-app.service';

export function provideClassicApp(): EnvironmentProviders {
  return makeEnvironmentProviders([provideAppInitializer(() => inject(ClassicAppService).init())]);
}
